<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventDiscounts"
        title-table="Descontos de Eventos"
        module="eventDiscountSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_EVENTOS_INSERIR"
        view-permission="ROLE_EVENTOS_CONSULTAR"
        edit-permission="ROLE_EVENTOS_ATUALIZAR"
        delete-permission="ROLE_EVENTOS_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <EventDiscountForm
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import EventDiscountForm from './form/EventDiscountForm.vue'

export default {
  name: 'EventDiscountSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    EventDiscountForm,
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'ID',
          field: 'id',
          width: '80px',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Evento',
          field: 'evento.nome',
        },
        {
          label: 'Tipo',
          field: 'tipo.nome',
        },
        {
          label: '% Desconto',
          field: 'percentualDesconto',
          formatter: value => (value ? `${value}%` : '-'),
        },
        {
          label: 'Valor Desconto',
          field: 'valorDesconto',
          formatter: value => (value
            ? value.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })
            : '-'),
        },
        {
          label: 'Status',
          field: 'ativo',
          formatter: value => (value ? 'Ativo' : 'Inativo'),
          width: '100px',
        },
        {
          label: 'Action',
          field: 'action',
          width: '80px',
        },
      ],
    }
  },
  computed: {
    ...mapState('eventDiscountSettingsModule', {
      listaEventDiscounts: state => state.listaEventDiscounts,
    }),
  },
  methods: {
    addNew() {
      this.$store.dispatch('eventDiscountSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('eventDiscountSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch('eventDiscountSettingsModule/reset')
    },
  },
}
</script>
